(function () {
  if (window.MavenProductStrapSelectorLoaded) return;
  window.MavenProductStrapSelectorLoaded = true;

  function closestSelector(element) {
    return element && element.closest('[data-product-strap-selector]');
  }

  function selectorFromElement(element) {
    var selector = closestSelector(element);
    if (selector) return selector;

    var modal = element && element.closest('[data-strap-selector-modal]');
    return modal && modal.__strapSelector ? modal.__strapSelector : null;
  }

  function formatMoney(cents, selector) {
    var format = selector && selector.dataset.moneyFormat || (window.theme && window.theme.moneyFormat);
    if (window.Currency && Currency.formatMoney) return Currency.formatMoney(cents, format);
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: 'JPY', currencyDisplay: 'narrowSymbol' });
  }

  function getCartAddUrl() {
    if (window.routes && window.routes.cartAddUrl) return window.routes.cartAddUrl + '.js';
    if (window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root + 'cart/add.js';
    return '/cart/add.js';
  }

  function getRoot(selector) {
    return selector.closest('[data-section-type="product"]') || selector.closest('.Product') || document;
  }

  function getModal(selector) {
    if (!selector) return null;
    var trigger = selector.querySelector('[data-strap-selector-open]');
    return selector.querySelector('[data-strap-selector-modal]') || (trigger && document.getElementById(trigger.getAttribute('aria-controls')));
  }

  function querySelectorAllWithModal(selector, query) {
    var results = Array.prototype.slice.call(selector.querySelectorAll(query));
    var modal = getModal(selector);
    if (modal && !selector.contains(modal)) {
      results = results.concat(Array.prototype.slice.call(modal.querySelectorAll(query)));
    }
    return results;
  }

  function getMainGalleryImage(selector) {
    var root = getRoot(selector);
    return root.querySelector('.main-product-images .slider-for .slick-current img.main--product--img') ||
      root.querySelector('.main-product-images .slider-for img.main--product--img');
  }

  function rememberImage(image) {
    if (!image || image.dataset.strapOriginalSrc) return;
    image.dataset.strapOriginalSrc = image.getAttribute('src') || '';
    image.dataset.strapOriginalSrcset = image.getAttribute('srcset') || '';
    image.dataset.strapOriginalDataSrcset = image.getAttribute('data-srcset') || '';
  }

  function setImage(image, src, srcset) {
    if (!image || !src) return;
    image.hidden = false;
    rememberImage(image);
    image.style.opacity = '0';
    window.setTimeout(function () { image.style.opacity = ''; }, 80);
    image.setAttribute('src', src);
    image.removeAttribute('data-src');
    if (srcset) {
      image.setAttribute('srcset', srcset);
      image.setAttribute('data-srcset', srcset);
    } else {
      image.removeAttribute('srcset');
      image.removeAttribute('data-srcset');
    }
  }

  function restoreImage(image) {
    if (!image || !image.dataset.strapOriginalSrc) return;
    image.hidden = false;
    image.setAttribute('src', image.dataset.strapOriginalSrc);
    if (image.dataset.strapOriginalSrcset) image.setAttribute('srcset', image.dataset.strapOriginalSrcset);else image.removeAttribute('srcset');
    if (image.dataset.strapOriginalDataSrcset) image.setAttribute('data-srcset', image.dataset.strapOriginalDataSrcset);else image.removeAttribute('data-srcset');
  }

  var fitImagePreloadCache = {};

  function preloadFitImage(src) {
    if (!src) return Promise.resolve(false);
    if (fitImagePreloadCache[src]) return fitImagePreloadCache[src];

    fitImagePreloadCache[src] = new Promise(function (resolve) {
      var preload = new Image();
      preload.onload = function () { resolve(true); };
      preload.onerror = function () { resolve(false); };
      preload.src = src;
    });

    return fitImagePreloadCache[src];
  }

  function prewarmFitImages(track) {
    if (!track || track.dataset.strapFitPrewarmed === 'true') return;
    track.dataset.strapFitPrewarmed = 'true';

    track.querySelectorAll('[data-strap-fit-image]').forEach(function (card) {
      preloadFitImage(card.dataset.strapFitImage || '');
    });
  }

  function swapFitImage(image, src, selector) {
    if (!image) return;
    window.clearTimeout(image._strapFitSwapTimer);

    if (!src) {
      clearImage(image);
      return;
    }

    var pauseMs = parseInt(selector && selector.dataset.strapFitPauseMs, 10);
    var fadeDelayMs = parseInt(selector && selector.dataset.strapFitFadeDelayMs, 10);
    if (!Number.isFinite(pauseMs)) pauseMs = 560;
    if (!Number.isFinite(fadeDelayMs)) fadeDelayMs = 140;

    image._strapFitSwapToken = (image._strapFitSwapToken || 0) + 1;
    var token = image._strapFitSwapToken;

    image.style.opacity = '0';
    image._strapFitSwapTimer = window.setTimeout(function () {
      if (token !== image._strapFitSwapToken) return;

      clearImage(image);

      preloadFitImage(src).then(function () {
        if (token !== image._strapFitSwapToken) return;

        image.hidden = false;
        image.style.opacity = '0';
        image.setAttribute('src', src);
        image.removeAttribute('srcset');
        image.removeAttribute('data-src');
        image.removeAttribute('data-srcset');

        window.setTimeout(function () {
          if (token !== image._strapFitSwapToken) return;
          image.style.opacity = '';
        }, fadeDelayMs);
      });
    }, pauseMs);
  }

  function clearImage(image) {
    if (!image) return;
    image.removeAttribute('src');
    image.removeAttribute('srcset');
    image.removeAttribute('data-src');
    image.removeAttribute('data-srcset');
    image.hidden = true;
  }

  function goToFirstSlide(selector) {
    var root = getRoot(selector);
    if (window.jQuery) {
      var $slider = window.jQuery(root).find('.main-product-images .slider-for');
      if ($slider.length && $slider.hasClass('slick-initialized')) $slider.slick('slickGoTo', 0);
    }
  }

  function openModal(selector) {
    var modal = getModal(selector);
    var trigger = selector.querySelector('[data-strap-selector-open]');
    if (!modal) return;
    resetSaveButtons(selector, true);
    if (!modal.__strapOriginalParent) {
      modal.__strapOriginalParent = modal.parentNode;
      modal.__strapOriginalNextSibling = modal.nextSibling;
    }
    modal.__strapSelector = selector;
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ProductStrapSelectorOpen');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function closeModal(selector) {
    if (!selector) return;
    var trigger = selector.querySelector('[data-strap-selector-open]');
    var modal = getModal(selector);
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ProductStrapSelectorOpen');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (modal.__strapOriginalParent && modal.parentNode === document.body) {
      modal.__strapOriginalParent.insertBefore(modal, modal.__strapOriginalNextSibling);
    }
  }

  function getTutorialDrawer(selector) {
    return selector && selector.querySelector('[data-strap-fit-tutorial-drawer]');
  }

  function openTutorialDrawer(selector) {
    var drawer = getTutorialDrawer(selector);
    var trigger = selector && selector.querySelector('[data-strap-fit-tutorial-open]');
    if (!drawer) return;

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ProductStrapFitTutorialOpen');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function closeTutorialDrawer(selector) {
    var drawer = getTutorialDrawer(selector);
    var trigger = selector && selector.querySelector('[data-strap-fit-tutorial-open]');
    if (!drawer) return;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ProductStrapFitTutorialOpen');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function closeOpenTutorialDrawers() {
    document.querySelectorAll('[data-product-strap-selector]').forEach(function (selector) {
      var drawer = getTutorialDrawer(selector);
      if (drawer && drawer.classList.contains('is-open')) closeTutorialDrawer(selector);
    });
  }

  function previewFitCard(selector, card, shouldCenter) {
    if (!selector || !card) return;

    var fitImage = selector.querySelector('[data-strap-fit-image]');
    var strapFitImage = card.dataset.strapFitImage || '';
    resetSaveButtons(selector);
    swapFitImage(fitImage, strapFitImage, selector);
    updateFitStatus(selector, card);
    updateSaveButtonAvailability(selector, card);
    if (shouldCenter !== false) centerCard(card);
  }

  function selectCard(selector, card) {
    if (!selector || !card) return;

    if (selector.dataset.strapSelectorMultiple === 'true') {
      resetSaveButtons(selector);
      card.classList.toggle('is-selected');
      updateMultiSelector(selector);

      if (selector.hasAttribute('data-strap-fit-selector')) {
        previewFitCard(selector, card, true);
      }

      return;
    }

    selector.querySelectorAll('[data-strap-selector-card]').forEach(function (item) {
      item.classList.remove('is-preview-hidden');
      item.classList.toggle('is-selected', item === card);
    });

    var variantInput = selector.querySelector('[data-strap-selector-variant-id]');
    var nameInput = selector.querySelector('[data-strap-selector-name]');
    var choices = selector.querySelectorAll('[data-strap-selector-choice]');
    var choicePrices = selector.querySelectorAll('[data-strap-selector-choice-price]');
    var empties = selector.querySelectorAll('[data-strap-selector-empty]');
    var edits = selector.querySelectorAll('[data-strap-selector-edit]');
    var resets = selector.querySelectorAll('[data-strap-selector-reset]');
    var triggerImageWrap = selector.querySelector('[data-strap-selector-trigger-image-wrap]');
    var triggerImage = selector.querySelector('[data-strap-selector-trigger-image]');
    var preview = selector.querySelector('[data-strap-selector-preview]');
    var mainImage = getMainGalleryImage(selector);
    var fitImage = selector.querySelector('[data-strap-fit-image]');

    var name = card.dataset.strapName || '';
    var variantId = card.dataset.strapVariantId || '';
    var previewImage = card.dataset.strapPreviewImage || '';
    var previewSrcset = card.dataset.strapPreviewSrcset || '';
    var cardImage = card.dataset.strapCardImage || previewImage;
    var strapFitImage = card.dataset.strapFitImage || '';
    var price = card.dataset.strapPrice ? formatMoney(parseInt(card.dataset.strapPrice, 10), selector) : '';

    resetSaveButtons(selector);

    if (variantInput) variantInput.value = variantId;
    if (nameInput) nameInput.value = name;
    choices.forEach(function (choice) {
      choice.textContent = name;
      choice.hidden = false;
    });
    choicePrices.forEach(function (choicePrice) {
      choicePrice.textContent = price;
      choicePrice.hidden = !price;
    });
    empties.forEach(function (empty) { empty.hidden = true; });
    edits.forEach(function (edit) { edit.hidden = false; });
    resets.forEach(function (reset) { reset.hidden = false; });
    if (triggerImage && cardImage) {
      triggerImage.src = cardImage;
      triggerImage.alt = name;
      if (triggerImageWrap) triggerImageWrap.hidden = false;
    }

    setImage(preview, previewImage, previewSrcset);
    swapFitImage(fitImage, strapFitImage, selector);
    updateFitStatus(selector, card);
    updateSaveButtonAvailability(selector, card);
    centerCard(card);

    if (!selector.hasAttribute('data-strap-fit-selector')) {
      goToFirstSlide(selector);
      setImage(mainImage, previewImage, previewSrcset);
    }
  }

  function readSelectedCards(selector) {
    return querySelectorAllWithModal(selector, '[data-strap-selector-card].is-selected');
  }

  function updateMultiSelector(selector) {
    var selectedCards = readSelectedCards(selector);
    var ids = selectedCards.map(function (card) { return card.dataset.strapVariantId || ''; }).filter(Boolean);
    var names = selectedCards.map(function (card) { return card.dataset.strapName || ''; }).filter(Boolean);
    var total = selectedCards.reduce(function (sum, card) {
      return sum + (parseInt(card.dataset.strapPrice, 10) || 0);
    }, 0);

    var variantInput = selector.querySelector('[data-strap-selector-variant-id]');
    var nameInput = selector.querySelector('[data-strap-selector-name]');
    var choices = selector.querySelectorAll('[data-strap-selector-choice]');
    var empties = selector.querySelectorAll('[data-strap-selector-empty]');
    var edits = selector.querySelectorAll('[data-strap-selector-edit]');
    var resets = selector.querySelectorAll('[data-strap-selector-reset]');
    var pillContainers = querySelectorAllWithModal(selector, '[data-strap-selector-modal-pills]');
    var summaries = querySelectorAllWithModal(selector, '[data-strap-selector-summary]');
    var totals = querySelectorAllWithModal(selector, '[data-strap-selector-total]');
    var hasSelection = ids.length > 0;

    if (variantInput) variantInput.value = hasSelection ? JSON.stringify(ids) : '';
    if (nameInput) nameInput.value = hasSelection ? JSON.stringify(names) : '';

    choices.forEach(function (choice) {
      choice.textContent = hasSelection ? names.join(' + ') : '';
      choice.hidden = !hasSelection;
    });
    empties.forEach(function (empty) { empty.hidden = hasSelection; });
    edits.forEach(function (edit) { edit.hidden = !hasSelection; });
    resets.forEach(function (reset) { reset.hidden = !hasSelection; });
    pillContainers.forEach(function (container) {
      container.innerHTML = '';
      names.forEach(function (name) {
        var pill = document.createElement('span');
        pill.className = 'ProductStrapSelector__SelectedPill';
        pill.textContent = name;
        container.appendChild(pill);
      });
    });
    summaries.forEach(function (summary) { summary.hidden = !hasSelection; });
    totals.forEach(function (totalElement) {
      totalElement.textContent = hasSelection ? formatMoney(total, selector) : '';
    });
  }

  function resetSelector(selector) {
    querySelectorAllWithModal(selector, '[data-strap-selector-card]').forEach(function (item) {
      item.classList.remove('is-selected');
      item.classList.remove('is-preview-hidden');
    });

    if (selector.dataset.strapSelectorMultiple === 'true') {
      updateMultiSelector(selector);
      return;
    }

    var variantInput = selector.querySelector('[data-strap-selector-variant-id]');
    var nameInput = selector.querySelector('[data-strap-selector-name]');
    var choices = selector.querySelectorAll('[data-strap-selector-choice]');
    var empties = selector.querySelectorAll('[data-strap-selector-empty]');
    var edits = selector.querySelectorAll('[data-strap-selector-edit]');
    var resets = selector.querySelectorAll('[data-strap-selector-reset]');
    var triggerImageWrap = selector.querySelector('[data-strap-selector-trigger-image-wrap]');
    var preview = selector.querySelector('[data-strap-selector-preview]');
    var mainImage = getMainGalleryImage(selector);
    var fitImage = selector.querySelector('[data-strap-fit-image]');

    resetSaveButtons(selector);

    if (variantInput) variantInput.value = '';
    if (nameInput) nameInput.value = '';
    choices.forEach(function (choice) {
      choice.textContent = '';
      choice.hidden = true;
    });
    empties.forEach(function (empty) { empty.hidden = false; });
    edits.forEach(function (edit) { edit.hidden = true; });
    resets.forEach(function (reset) { reset.hidden = true; });
    if (triggerImageWrap) triggerImageWrap.hidden = true;
    restoreImage(preview);
    restoreImage(mainImage);
    clearImage(fitImage);

    if (selector.hasAttribute('data-strap-fit-selector')) {
      var track = selector.querySelector('[data-strap-fit-track]');
      var centered = getCenteredFitCard(track);
      if (centered) centered.classList.add('is-preview-hidden');
      resetFitStatus(selector);
    }
  }

  function scrollFitTrack(button, direction) {
    var selector = selectorFromElement(button);
    var track = selector && selector.querySelector('[data-strap-fit-track]');
    if (!selector || !track) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-strap-selector-card]'));
    if (!cards.length) return;

    var isMultiFitSelector = selector.dataset.strapSelectorMultiple === 'true' && selector.hasAttribute('data-strap-fit-selector');
    var current = (isMultiFitSelector ? getCenteredFitCard(track) : selector.querySelector('[data-strap-selector-card].is-selected')) || getCenteredFitCard(track) || cards[0];
    var currentIndex = Math.max(cards.indexOf(current), 0);
    var nextIndex = Math.min(Math.max(currentIndex + direction, 0), cards.length - 1);
    var nextCard = cards[nextIndex];

    if (!nextCard || nextCard === current) return;
    window.clearTimeout(track._strapFitScrollTimer);

    if (isMultiFitSelector) {
      previewFitCard(selector, nextCard, true);
      return;
    }

    selectCard(selector, nextCard);
  }

  function centerCard(card) {
    var track = card && card.closest('[data-strap-fit-track]');
    if (!track) return;

    var left = card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
    track.scrollTo({ left: left, behavior: 'smooth' });
  }

  function updateFitStatus(selector, card) {
    if (!selector || !card) return;

    var cards = Array.prototype.slice.call(selector.querySelectorAll('[data-strap-selector-card]'));
    var total = cards.length;
    var index = cards.indexOf(card) + 1;
    if (!total || index < 1) return;

    selector.querySelectorAll('[data-strap-fit-current]').forEach(function (element) {
      element.textContent = index;
    });
    selector.querySelectorAll('[data-strap-fit-total]').forEach(function (element) {
      element.textContent = total;
    });
    selector.querySelectorAll('[data-strap-fit-progress]').forEach(function (element) {
      element.style.width = (index / total * 100) + '%';
    });
  }


  function getCenteredFitCard(track) {
    if (!track) return null;

    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-strap-selector-card]'));
    if (!cards.length) return null;

    var trackRect = track.getBoundingClientRect();
    var center = trackRect.left + trackRect.width / 2;
    var closest = cards.reduce(function (best, card) {
      var rect = card.getBoundingClientRect();
      var cardCenter = rect.left + rect.width / 2;
      var distance = Math.abs(cardCenter - center);
      if (!best || distance < best.distance) return { card: card, distance: distance };
      return best;
    }, null);

    return closest && closest.card ? closest.card : null;
  }

  function resetFitStatus(selector) {
    if (!selector) return;

    selector.querySelectorAll('[data-strap-fit-current]').forEach(function (element) {
      element.textContent = '0';
    });
    selector.querySelectorAll('[data-strap-fit-progress]').forEach(function (element) {
      element.style.width = '0%';
    });
  }

  function selectCenteredFitCard(track) {
    if (!track) return;

    var card = getCenteredFitCard(track);
    if (!card) return;

    var selector = selectorFromElement(card);
    if (selector && selector.hasAttribute('data-strap-fit-selector')) {
      previewFitCard(selector, card, false);
      return;
    }

    updateFitStatus(selector, card);
    if (card.classList.contains('is-selected')) return;
    selectCard(selector, card);
  }

  function scheduleCenteredFitSelection(track) {
    if (!track) return;

    window.clearTimeout(track._strapFitScrollTimer);
    track._strapFitScrollTimer = window.setTimeout(function () {
      selectCenteredFitCard(track);
    }, 140);
  }

  function initializeFitTrack(track) {
    if (!track || track.dataset.strapFitInitialized === 'true') return;

    var selected = track.querySelector('[data-strap-selector-card].is-selected');
    var firstAvailable = track.querySelector('[data-strap-selector-card][data-strap-available="true"]');
    var first = selected || firstAvailable || track.querySelector('[data-strap-selector-card]');
    if (!first) return;

    track.dataset.strapFitInitialized = 'true';
    prewarmFitImages(track);

    var selector = selectorFromElement(first);
    if (selector && selector.hasAttribute('data-strap-fit-selector')) {
      previewFitCard(selector, first, true);
      return;
    }

    selectCard(selector, first);
  }

  function initializeFitTracks(root) {
    (root || document).querySelectorAll('[data-strap-fit-track]').forEach(function (track) {
      initializeFitTrack(track);
    });
  }

  function updateFitSectionVisibility() {
    var visible = false;
    document.querySelectorAll('[data-strap-fit-selector].ProductStrapFitSelector--inline_full_width').forEach(function (selector) {
      var rect = selector.getBoundingClientRect();
      if (rect.bottom > 80 && rect.top < window.innerHeight - 80) visible = true;
    });
    document.body.classList.toggle('ProductStrapFitSelectorInView', visible);
  }

  function observeFitSectionVisibility(root) {
    var selectors = (root || document).querySelectorAll('[data-strap-fit-selector].ProductStrapFitSelector--inline_full_width');
    if (!selectors.length) return;

    if ('IntersectionObserver' in window) {
      if (!window.__mavenStrapFitObserver) {
        window.__mavenStrapFitVisibleCount = 0;
        window.__mavenStrapFitObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var wasVisible = entry.target.dataset.strapFitInView === 'true';
            var isVisible = entry.isIntersecting;
            if (wasVisible === isVisible) return;
            entry.target.dataset.strapFitInView = isVisible ? 'true' : 'false';
            window.__mavenStrapFitVisibleCount += isVisible ? 1 : -1;
          });
          document.body.classList.toggle('ProductStrapFitSelectorInView', window.__mavenStrapFitVisibleCount > 0);
        }, { rootMargin: '-80px 0px -80px 0px', threshold: 0.08 });
      }

      selectors.forEach(function (selector) {
        if (selector.dataset.strapFitVisibilityObserved === 'true') return;
        selector.dataset.strapFitVisibilityObserved = 'true';
        selector.dataset.strapFitInView = 'false';
        window.__mavenStrapFitObserver.observe(selector);
      });
    } else {
      updateFitSectionVisibility();
      window.addEventListener('scroll', updateFitSectionVisibility, { passive: true });
      window.addEventListener('resize', updateFitSectionVisibility);
    }
  }

  var dragState = null;

  function startTrackDrag(event) {
    var track = event.target.closest('[data-strap-fit-track]');
    if (!track || event.button && event.button !== 0) return;

    dragState = {
      track: track,
      startX: event.clientX,
      scrollLeft: track.scrollLeft,
      moved: false
    };
    track.classList.add('is-dragging');
    track.dataset.strapDragging = 'false';
  }

  function moveTrackDrag(event) {
    if (!dragState) return;

    var delta = event.clientX - dragState.startX;
    if (Math.abs(delta) > 6) {
      dragState.moved = true;
      dragState.track.dataset.strapDragging = 'true';
    }
    dragState.track.scrollLeft = dragState.scrollLeft - delta;
  }

  function endTrackDrag() {
    if (!dragState) return;

    var track = dragState.track;
    track.classList.remove('is-dragging');
    if (dragState.moved) {
      window.setTimeout(function () { track.dataset.strapDragging = 'false'; }, 80);
    } else {
      track.dataset.strapDragging = 'false';
    }
    dragState = null;
  }

  function getSelectedSelector(form) {
    if (!form) return null;
    var section = form.closest('[data-section-type="product"]') || document;
    var selectors = Array.prototype.slice.call(section.querySelectorAll('[data-product-strap-selector]'));
    var selected = selectors.find(function (selector) {
      var input = selector.querySelector('[data-strap-selector-variant-id]');
      return input && input.value && selector.dataset.strapSelectorAddedToCart !== 'true';
    });

    if (selected) return selected;

    return Array.prototype.slice.call(document.querySelectorAll('[data-product-strap-selector]')).find(function (selector) {
      var input = selector.querySelector('[data-strap-selector-variant-id]');
      return input && input.value && selector.dataset.strapSelectorAddedToCart !== 'true';
    }) || null;
  }

  function parseSelectedValues(value) {
    if (!value) return [];
    try {
      var parsed = JSON.parse(value);
      if (Array.isArray(parsed)) return parsed;
    } catch (error) {}
    return [value];
  }

  function readFormProperties(form) {
    var properties = {};
    var formData = new FormData(form);
    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match && value !== '') properties[match[1]] = value;
    });
    return properties;
  }

  function showError(button, message) {
    if (!button) return;
    var oldError = button.parentNode && button.parentNode.querySelector('.ProductForm__Error');
    if (oldError) oldError.remove();
    var error = document.createElement('span');
    error.className = 'ProductForm__Error Alert Alert--error';
    error.textContent = message || 'Unable to add the selected strap. Please try again.';
    button.insertAdjacentElement('afterend', error);
    window.setTimeout(function () { error.remove(); }, 3000);
  }

  function getButtonLabel(button) {
    return button ? button.textContent.trim() : '';
  }

  function setButtonLabel(button, label) {
    if (!button || !label) return;
    button.textContent = label;
  }

  function resetSaveButtons(selector, preserveAddedState) {
    if (!selector) return;

    if (!preserveAddedState) delete selector.dataset.strapSelectorAddedToCart;

    selector.querySelectorAll('[data-strap-selector-save-to-cart]').forEach(function (button) {
      if (button.dataset.defaultLabel) setButtonLabel(button, button.dataset.defaultLabel);
      button.classList.remove('is-added');
      button.classList.remove('is-sold-out');
      button.removeAttribute('disabled');
      button.removeAttribute('aria-disabled');
    });
  }

  function updateSaveButtonAvailability(selector, card) {
    if (!selector || !card) return;

    var isAvailable = card.dataset.strapAvailable !== 'false';
    selector.querySelectorAll('[data-strap-selector-save-to-cart]').forEach(function (button) {
      if (!button.dataset.defaultLabel) button.dataset.defaultLabel = getButtonLabel(button);

      if (isAvailable) {
        button.classList.remove('is-sold-out');
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
        setButtonLabel(button, button.dataset.defaultLabel);
        return;
      }

      button.classList.remove('is-added');
      button.classList.add('is-sold-out');
      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-disabled', 'true');
      setButtonLabel(button, selector.dataset.soldOutLabel || '売り切れ');
    });
  }

  function setSaveButtonLoading(button, isLoading) {
    if (!button) return;

    if (!button.dataset.defaultLabel) button.dataset.defaultLabel = getButtonLabel(button);
    if (isLoading) {
      button.setAttribute('disabled', 'disabled');
      button.classList.add('is-loading');
    } else {
      button.classList.remove('is-loading');
      button.removeAttribute('disabled');
    }
  }

  function addSelectedStrapsToCart(selector, button) {
    if (!selector || !button) return;

    var selectedVariantInput = selector.querySelector('[data-strap-selector-variant-id]');
    var strapVariantIds = parseSelectedValues(selectedVariantInput && selectedVariantInput.value);
    var unavailableCards = readSelectedCards(selector).filter(function (card) { return card.dataset.strapAvailable === 'false'; });

    if (unavailableCards.length) {
      showError(button, selector.dataset.soldOutLabel || '売り切れ');
      updateSaveButtonAvailability(selector, unavailableCards[0]);
      return;
    }

    if (!strapVariantIds.length) {
      showError(button, 'ストラップを選択してください');
      return;
    }

    setSaveButtonLoading(button, true);
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch(getCartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: strapVariantIds.map(function (strapVariantId) {
          return {
            id: String(strapVariantId),
            quantity: 1
          };
        })
      })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (content) {
          throw new Error(content.description || content.message || 'Unable to add the selected strap. Please try again.');
        });
      }
      return response.json();
    }).then(function () {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      button.classList.remove('is-loading');
      button.classList.add('is-added');
      button.setAttribute('disabled', 'disabled');
      setButtonLabel(button, button.dataset.strapSelectorAddedLabel || 'カートに追加しました');
      selector.dataset.strapSelectorAddedToCart = 'true';
      if (button.closest('[data-strap-selector-modal]')) closeModal(selector);
      getRoot(selector).dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: { id: String(strapVariantIds[0]) },
          quantity: strapVariantIds.length
        }
      }));
    }).catch(function (error) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      setSaveButtonLoading(button, false);
      showError(button, error.message);
    });
  }

  function addBundle(event, button) {
    var form = button.closest('form[action*="/cart/add"]');
    var selector = getSelectedSelector(form);
    if (!selector) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    var selectedVariantInput = selector.querySelector('[data-strap-selector-variant-id]');
    var watchVariantInput = form.querySelector('[name="id"]');
    var quantityInput = form.querySelector('[name="quantity"]');
    var watchVariantId = watchVariantInput && watchVariantInput.value;
    var strapVariantIds = parseSelectedValues(selectedVariantInput && selectedVariantInput.value);
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    if (!watchVariantId || !strapVariantIds.length) return;

    var watchProperties = readFormProperties(form);
    var watchItem = { id: String(watchVariantId), quantity: quantity };

    if (Object.keys(watchProperties).length) {
      watchItem.properties = watchProperties;
    }

    var items = [
      watchItem
    ].concat(strapVariantIds.map(function (strapVariantId) {
      return {
        id: String(strapVariantId),
        quantity: quantity
      };
    }));

    button.setAttribute('disabled', 'disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch(getCartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: items
      })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (content) {
          throw new Error(content.description || content.message || 'Unable to add the selected strap. Please try again.');
        });
      }
      return response.json();
    }).then(function () {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      button.removeAttribute('disabled');

      if (selector.dataset.useAjaxCart === 'false') {
        window.location.href = (window.routes && window.routes.cartUrl) ? window.routes.cartUrl : '/cart';
        return;
      }

      var productSection = form.closest('[data-section-type="product"]') || form;
      productSection.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: { id: String(watchVariantId) },
          quantity: quantity
        }
      }));
    }).catch(function (error) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      button.removeAttribute('disabled');
      showError(button, error.message);
    });
  }

  document.addEventListener('click', function (event) {
    var tutorialOpen = event.target.closest('[data-strap-fit-tutorial-open]');
    if (tutorialOpen) {
      event.preventDefault();
      openTutorialDrawer(selectorFromElement(tutorialOpen));
      return;
    }

    var tutorialClose = event.target.closest('[data-strap-fit-tutorial-close]');
    if (tutorialClose) {
      event.preventDefault();
      closeTutorialDrawer(selectorFromElement(tutorialClose));
      return;
    }

    var openButton = event.target.closest('[data-strap-selector-open]');
    if (openButton) {
      event.preventDefault();
      openModal(closestSelector(openButton));
      return;
    }

    var closeButton = event.target.closest('[data-strap-selector-close]');
    if (closeButton) {
      event.preventDefault();
      closeModal(selectorFromElement(closeButton));
      return;
    }

    var card = event.target.closest('[data-strap-selector-card]');
    if (card) {
      event.preventDefault();
      var dragTrack = card.closest('[data-strap-fit-track]');
      if (dragTrack && dragTrack.dataset.strapDragging === 'true') return;
      selectCard(selectorFromElement(card), card);
      return;
    }

    var prev = event.target.closest('[data-strap-fit-prev]');
    if (prev) {
      event.preventDefault();
      scrollFitTrack(prev, -1);
      return;
    }

    var next = event.target.closest('[data-strap-fit-next]');
    if (next) {
      event.preventDefault();
      scrollFitTrack(next, 1);
      return;
    }

    var save = event.target.closest('[data-strap-selector-save]');
    if (save) {
      event.preventDefault();
      if (save.hasAttribute('data-strap-selector-save-to-cart')) {
        addSelectedStrapsToCart(selectorFromElement(save), save);
      } else {
        closeModal(selectorFromElement(save));
      }
      return;
    }

    var reset = event.target.closest('[data-strap-selector-reset]');
    if (reset) {
      event.preventDefault();
      resetSelector(selectorFromElement(reset));
      return;
    }
  });

  document.addEventListener('dragstart', function (event) {
    if (event.target && event.target.closest && event.target.closest('[data-strap-fit-track]')) {
      event.preventDefault();
    }
  });

  document.addEventListener('pointerdown', startTrackDrag);
  document.addEventListener('pointermove', moveTrackDrag);
  document.addEventListener('pointerup', endTrackDrag);
  document.addEventListener('pointercancel', endTrackDrag);

  document.addEventListener('scroll', function (event) {
    var track = event.target && event.target.closest && event.target.closest('[data-strap-fit-track]');
    if (!track) return;
    scheduleCenteredFitSelection(track);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeFitTracks(document);
      observeFitSectionVisibility(document);
    });
  } else {
    initializeFitTracks(document);
    observeFitSectionVisibility(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeFitTracks(event.target || document);
    observeFitSectionVisibility(event.target || document);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.ProductForm__AddToCart[data-action="add-to-cart"]');
    if (!button) return;
    addBundle(event, button);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closeOpenTutorialDrawers();
    document.querySelectorAll('[data-product-strap-selector] [data-strap-selector-modal].is-open').forEach(function (modal) {
      closeModal(selectorFromElement(modal));
    });
    document.querySelectorAll('body > [data-strap-selector-modal].is-open').forEach(function (modal) {
      closeModal(selectorFromElement(modal));
    });
  });
})();
